import script from "./alterationEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./alterationEmail.vue?vue&type=script&setup=true&lang=js"

import "./alterationEmail.vue?vue&type=style&index=0&id=a2a04720&lang=scss"

const __exports__ = script;

export default __exports__